import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What is a local business database?',
  answer: 'A local business database is a comprehensive directory of local small businesses, including their contact information, firmographics, and key personnel. Our platform provides verified local business listings and acts as a local business owner finder to help you connect with decision-makers.'
}, {
  question: 'How do I find local business owner emails?',
  answer: 'You can use our local business owner finder to search for specific industries or locations. Once you identify your target local small businesses, you can unlock verified business owner emails directly within the platform.'
}, {
  question: 'What local business listings are available?',
  answer: 'We offer local business listings across 300+ categories, from accounting and healthcare to home services and retail. Each listing includes 50+ data points such as company size, revenue estimates, tech stack, and verified contact information.'
}, {
  question: 'Can I search for local small businesses by category?',
  answer: 'Yes, our directory allows you to browse local small businesses by category or search for specific niches. You can filter your search by location, employee count, revenue, and more to build the perfect list.'
}, {
  question: 'How accurate are the business owner emails?',
  answer: 'Every business owner email is verified in real-time before you export or sequence them. We check for deliverability, catch-all status, and bounce risks to ensure your outreach campaigns maintain a high sender reputation.'
}, {
  question: 'Can I export local business contacts?',
  answer: 'Absolutely. You can export your local businesses list to a CSV file or sync it directly to your CRM (like Salesforce or HubSpot). Alternatively, you can use our built-in email sequencing to contact them without leaving the platform.'
}];
export function DataDirectoryFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-slate-50" data-id="element-702">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-703">
        <div className="text-center mb-12" data-id="element-704">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-705">
            Frequently asked questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-706">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white border border-slate-200 rounded-2xl overflow-hidden" data-id="element-707">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-708">
                  <span className="text-base font-bold text-slate-900 pr-8" data-id="element-709">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-710" />
                </button>
                <AnimatePresence data-id="element-711">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-712">
                      <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-713">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}